import React from 'react'
import Credits from './credits'
import CreditLine from './creditline'
import creditssectionStyles from '../../styles/modules/creditssection.module.less'

const CreditsSection = ({ data }) => {
  const cleanCredits = data.slice(1) // first one is headers
  let creditObj = {}
  for (var credit in cleanCredits) {
    if (typeof creditObj[cleanCredits[credit].role] === 'undefined') {
      // Create an empty array with key of role
      creditObj[cleanCredits[credit].role] = []
    }
    // Push into role array regardless
    creditObj[cleanCredits[credit].role].push(cleanCredits[credit])
  }

  return (
    <section aria-label="Credits" className={creditssectionStyles.section}>
      <h4 className={creditssectionStyles.hed}>Credits</h4>
      {Object.keys(creditObj).map(function (key, k) {
        return (
          <Credits type={key} key={'credits' + k}>
            {creditObj[key].map((credit, i) => {
              return (
                <CreditLine
                  key={'credit' + i}
                  name={credit.name}
                  email={credit.email}
                  twitter={credit.twitter}
                />
              )
            })}
          </Credits>
        )
      })}
      <p>Illustration by Getty Images</p>
    </section>
  )
}

export default CreditsSection
